import { primaryColor, blackColors, hexToRgb, whiteColor, blackColor } from 'assets/jss/material-dashboard-pro-react';
import customSelectorsStyle from './customSelectorsStyle';

const customToggleStyle = {
	...customSelectorsStyle,
	switchBase: {
		color: primaryColor[0] + '!important',
		padding: '13px',
	},
	switchIcon: {
		height: '22px',
		width: '22px',
		boxShadow: '0 1px 3px 1px rgba(' + hexToRgb(blackColor) + ', 0.4)',
		color: whiteColor + ' !important',
	},
	switchIconChecked: {
		boxShadow: `
      0 1px 3px 1px ${blackColors[3]},
      0 7px 10px -5px rgba(${hexToRgb(primaryColor[0])}, 0.4)
    `,
		transform: 'translateX(0px)!important',
	},
	switchBar: {
		opacity: '1 !important',
		width: '40px',
		height: '24px',
		backgroundColor: blackColors[2],
		borderRadius: '12px',
	},
	switchBaseDisabled: {
		'& + span$switchBar': {
			backgroundColor: `${blackColors[6]} !important`,
		},
		'& span$switchIcon': {
			border: 'none',
			boxShadow: 'none',
		},
	},
	switchChecked: {
		'& + $switchBar': {
			backgroundColor: 'rgba(' + hexToRgb(primaryColor[0]) + ', 1) !important',
		},
	},
	switchRoot: {
		height: 24 + 12 * 2,
		width: 64,
	},
	uncheckedIcon: {},
	checkedIcon: {},
	radioChecked: {},
	radioUnchecked: {},
};

export default customToggleStyle;
